import * as React from "react";
import { colors, useTextStyles } from "../styles";
import { PersonSupport24Regular, SignOut24Filled } from "@fluentui/react-icons";
import { makeStyles, useToastController } from "@fluentui/react-components";
import { logout } from "../../utils/auth";
import { Screen } from "../../utils/common/constants";
import { notify } from "./Toast";

export interface FooterProps {
  activeScreen: String;
}

const useStyles = makeStyles({
  footerSection: {
    boxShadow: "lightgrey 0px -2px 5px",
    padding: "20px 10px"
  },
  footerContainer: {
    display: "flex",
    justifyContent: "space-around",
    color: colors.fundwave
  },
  btnContainer: {
    gap: "5px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer"
  }
});

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  const textStyles = useTextStyles();
  const styles = useStyles();
  const supportUrl = "https://fundwave.com/support/";

  const { dispatchToast } = useToastController();

  return (
    <section className={styles.footerSection}>
      <div className={styles.footerContainer}>
        {/* Support */}
        <a className={textStyles.linkText} href={supportUrl} target="_blank">
          <PersonSupport24Regular />
          <span>Support</span>
        </a>

        {/* Sign out */}
        {![Screen.Login, Screen.EditorWarning].includes(props.activeScreen as Screen) && (
          <div
            onClick={() => {
              dispatchToast(notify("Signing out..."), { intent: "info", timeout: 5000, position: "bottom" });
              logout();
            }}
            className={styles.btnContainer}
          >
            <SignOut24Filled />
            <span>Sign Out</span>
          </div>
        )}
      </div>
    </section>
  );
};

export default Footer;
